import { Link } from "react-router-dom";
import { SITE } from "../config/site";
import { useDocumentTitle } from "../components/ui";
import { useT } from "../i18n";

export function PrivacyPage() {
  const t = useT();
  useDocumentTitle(t("Chính sách quyền riêng tư", "Privacy policy"));
  return (
    <article className="prose card reading-page">
      <h1>{t("Chính sách quyền riêng tư", "Privacy policy")}</h1>
      <p className="small muted">{t("Cập nhật", "Updated")}: 2026-11-05 · {SITE.name}</p>

      <h2>{t("Dữ liệu chúng tôi thu thập", "What we collect")}</h2>
      <ul>
        <li>{t("Khi bạn đăng nhập bằng Google: mã định danh tài khoản Google, email, tên hiển thị và ảnh đại diện.", "When you sign in with Google: your Google account identifier, email, display name and profile picture.")}</li>
        <li>{t("Tiến độ học: câu đã làm, kết quả thi thử, huy hiệu, lịch ôn tập.", "Study progress: answered questions, mock exam results, badges and review schedule.")}</li>
        <li>{t("Góp ý bạn gửi (và email nếu bạn tự điền).", "Feedback you submit (and an email address if you choose to provide one).")}</li>
      </ul>
      <p>{t("Chúng tôi không nhận mật khẩu Google, không đọc email hay dữ liệu Google khác của bạn, không dùng cookie quảng cáo.", "We never receive your Google password, never read your email or other Google data, and use no advertising cookies.")}</p>

      <h2>{t("Mục đích sử dụng", "How we use it")}</h2>
      <p>{t("Chỉ để đăng nhập, lưu và đồng bộ tiến độ học giữa các thiết bị, và cải thiện nội dung từ góp ý. Không bán, không chia sẻ dữ liệu cho bên thứ ba.", "Only to sign you in, save and sync your progress across devices, and improve content based on feedback. We never sell or share your data with third parties.")}</p>

      <h2>{t("Lưu trữ", "Storage")}</h2>
      <p>{t("Dữ liệu lưu trên máy chủ riêng của dự án (PostgreSQL), truyền qua HTTPS. Một bản tiến độ cũng được lưu trong trình duyệt của bạn để dùng nhanh.", "Data is stored on the project's own server (PostgreSQL) and transmitted over HTTPS. A copy of your progress is also kept in your browser for speed.")}</p>

      <h2>{t("Quyền của bạn", "Your rights")}</h2>
      <p>{t("Bạn có thể xóa vĩnh viễn tài khoản và toàn bộ tiến độ bất cứ lúc nào: bấm ảnh đại diện trên thanh đầu trang → “Xóa tài khoản”. Góp ý đã gửi được giữ lại nhưng tách khỏi tài khoản.", "You can permanently delete your account and all progress at any time: click your avatar in the header → “Delete account”. Feedback you sent is kept but unlinked from your account.")}</p>

      <h2>{t("Liên hệ", "Contact")}</h2>
      <p>{t("Mọi thắc mắc về dữ liệu, gửi qua trang ", "For any data questions, use the ")}<Link to="/feedback">{t("Góp ý", "Feedback")}</Link>{t(".", " page.")}</p>
    </article>
  );
}
